import { FolderPlus, Wind, MapPin, Grid3x3, FileCheck, Check } from "lucide-react";

import { tr } from "@/lib/i18n";
const STEPS = [
  { name: tr("Dati di progetto"), icon: FolderPlus },
  { name: tr("Carichi"), icon: Wind },
  { name: tr("Edificio"), icon: MapPin },
  { name: tr("Bozza · moduli"), icon: Grid3x3 },
  { name: tr("Risultati"), icon: FileCheck },
];

export const Stepper = ({ current, maxStep, onSelect }) => (
  <nav className="shrink-0 bg-white border-b border-slate-200 px-2 sm:px-6 overflow-x-auto" data-testid="wizard-stepper">
    <ol className="flex items-center min-w-max">
      {STEPS.map((s, i) => {
        const n = i + 1;
        const active = n === current;
        const done = n < current || n <= maxStep;
        const Icon = done && !active ? Check : s.icon;
        return (
          <li key={s.name} className="flex items-center">
            <button
              data-testid={`step-${n}-btn`}
              onClick={() => onSelect(n)}
              className={`flex items-center gap-2.5 px-3 sm:px-4 h-14 border-b-2 transition-colors ${active ? "border-[#0F52BA] text-[#0F52BA]" : "border-transparent text-slate-500 hover:text-slate-900"}`}
            >
              <span className={`w-7 h-7 rounded-full grid place-items-center text-xs font-semibold transition-colors ${active ? "bg-[#0F52BA] text-white" : done ? "bg-blue-50 text-[#0F52BA]" : "bg-slate-100 text-slate-500"}`}>
                <Icon className="w-3.5 h-3.5" />
              </span>
              <span className="text-sm font-medium whitespace-nowrap"><span className="font-tech text-xs mr-1 opacity-60">0{n}</span>{s.name}</span>
            </button>
            {n < 5 && <span className="w-6 h-px bg-slate-200 mx-1" />}
          </li>
        );
      })}
    </ol>
  </nav>
);
